import React from "react";
import PrintSlip from "./PrintSlip";
import AcceptanceLetter from "./AcceptanceLetter";

const PrintAcceptance = ({ v }) => {
  return (
    <div>
      <PrintSlip v={v} />
      <AcceptanceLetter v={v} />
    </div>
  );
};

export default PrintAcceptance;
